/* eslint-disable @typescript-eslint/no-empty-function */
import Modal from "common/components/Modal/Modal"
import { DOC_TYPE_FORMAT } from "common/constants"
import { useDownloadFileContext } from "common/context/DownloadFileProvider"
import { AppContext } from "common/context/WithAppWrapper"
import notification from "common/utils/notification"
import { useContext } from "react"
import { useTranslation } from "react-i18next"

const DOWNLOAD_SUCCESS_MSG = "Documento descargado correctamente."
const DOWNLOAD_FAILURE_MSG = "Han surgido problemas descargando el documento."

const DownloadDocumentoModal = ({
  onHide,
  downloadPdf,
  downloadXml,
  downloadEdi,
  visible,
  fileName,
  id,
  title = "factura",
  formatValue,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  // @ts-expect-error TS(2339): Property 'settings' does not exist on type 'unknow...
  const { settings } = useContext(AppContext)
  const downloadFile = useDownloadFileContext()

  const notificationSuccess = () => {
    notification.success({ body: DOWNLOAD_SUCCESS_MSG })
  }

  const notificationError = () => {
    notification.errorServidor({
      body: DOWNLOAD_FAILURE_MSG,
    })
  }

  const docTypeParameters = {
    PDF: {
      fetchDowload: downloadPdf,
      download: downloadFile.handleDownloadPdf,
      setDownloadingStatus: () => {},
    },
    XML: {
      fetchDowload: downloadXml,
      download: downloadFile.handleDownloadXml,
      setDownloadingStatus: () => {},
    },
    EDI: {
      fetchDowload: downloadEdi,
      download: downloadFile.handleDownloadEdi,
      setDownloadingStatus: () => {},
    },
  }

  const handleDownload = async (
    key: $TSMigrationFixMe,
    formatValue: $TSMigrationFixMe
  ) => {
    try {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
      docTypeParameters[key].setDownloadingStatus(true)
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
      const { data } = await docTypeParameters[key].fetchDowload(
        id,
        formatValue
      )
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
      docTypeParameters[key].download(fileName, data)

      notificationSuccess()
    } catch (error) {
      notificationError()
    }
  }

  return (
    <Modal
      onHide={onHide}
      visible={visible}
      header={`Descargar ${title}`}
    >
      <div className='m-0 row d-flex justify-content-center'>
        {downloadPdf && (
          <div className='p-0 col-md-4 col-sm-12'>
            <div
              className='mt-4 modal-element'
              // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
              onClick={() => handleDownload("PDF")}
            >
              <img
                src={settings.pdf}
                alt='document-icon'
              />
              {/* TODO: i18n */}
              <span className='m-1'>PDF</span>
              <p>{t("crear.presupuesto.modal.msg.pdfMsg")}</p>
            </div>
          </div>
        )}

        {downloadXml && (
          <div className='p-0 col-md-4 col-sm-12'>
            <div
              className='mt-4 modal-element'
              onClick={() => handleDownload("XML", DOC_TYPE_FORMAT.FACTURA_E)}
            >
              <img
                src={settings.xml}
                alt='document-icon'
              />
              <span className='m-1'>FACTURAE</span>
              <p>{t("crear.presupuesto.modal.facturaEMsg")}</p>
            </div>
          </div>
        )}

        {downloadEdi && (
          <div className='p-0 col-md-4 col-sm-12'>
            <div
              className='mt-4 modal-element'
              onClick={() => handleDownload("EDI", formatValue)}
            >
              <img
                src={settings.edi}
                alt='document-icon'
              />
              <span className='m-1'>EDIFACT</span>
              <p>{t("crear.presupuesto.modal.msg.edifactMsg")}</p>
            </div>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default DownloadDocumentoModal
